import {
Component,
Injector,
Optional,
SecurityContext
} from '@angular/core';
import {CommonModule} from "@angular/common";
import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, styler, register, TrustAsPipe } from "@wm/components-base";
import { generateGUId, runtimeEventManager, setCSS } from '@wm/core';
import { SafeResourceUrl } from '@angular/platform-browser';

const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-iframedialog',
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmIframeDialog]',
  template: `<div class="app-view dialog-view clearfix" wm-navigable-element="true">
    <div class="app-dialog modal-dialog app-iframe-dialog" [ngStyle]="{width: width}" *ngIf="loadDialogContent">
      <div class="modal-content">
        <div class="app-dialog-header modal-header">
          <button aria-label="Close" class="app-dialog-close close" [ngClass]="{'btn-text': isPrism}" title="Close">
            <span class="app-icon wi wi-clear" aria-hidden="true"></span>
          </button>
          <!-- Change the header tag based on the heading level -->
          <ng-container [ngSwitch]="headinglevel">
            <ng-container *ngSwitchCase="'h1'">
              <h1 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h1>
            </ng-container>
            <ng-container *ngSwitchCase="'h2'">
              <h2 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h2>
            </ng-container>
            <ng-container *ngSwitchCase="'h3'">
              <h3 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h3>
            </ng-container>
            <ng-container *ngSwitchCase="'h4'">
              <h4 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h4>
            </ng-container>
            <ng-container *ngSwitchCase="'h5'">
              <h5 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h5>
            </ng-container>
            <ng-container *ngSwitchCase="'h6'">
              <h6 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h6>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <h4 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h4>
            </ng-container>
          </ng-container>
          <ng-template #headerTemplate>
            <i [ngClass]="iconclass" [ngStyle]="{width: iconwidth, height: iconheight, margin: iconmargin}"  *ngIf="iconclass && !iconurl"></i>
            <img data-identifier="img" [src]="iconurl" *ngIf="iconurl" [ngStyle]="{width:iconwidth, height:iconheight, margin:iconmargin}"/>
            <span class="dialog-heading" [textContent]="title" [id]="titleId"></span>
          </ng-template>
        </div>
        <div class="app-dialog-body modal-body" apply-styles="scrollable-container" style="overflow: auto; height: 400px">
          <div class="embed-responsive app-iframe app-iframe-dialog" style="height: 100%;">
            <iframe class="embed-responsive-item iframe-content" scrolling="auto" marginheight="0" marginwidth="0" frameborder="0"
                    title="{{hint}}"role="document" [attr.src]="_iframesrc" seamless="seamless">
            </iframe>
          </div>
        </div>
        <div class="app-dialog-footer modal-footer" ng-if="showactions">
          <button class="btn-primary ok-action btn app-button" aria-label="Submit button">{{oktext}}</button>
        </div>
      </div>
    </div>
</div>
`,
  providers: [
    provideAsWidgetRef(IframeDialogComponent),
    TrustAsPipe
  ],
  exportAs: 'wmIframeDialog',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class IframeDialogComponent extends StylableComponent {
  static initializeProps = register('wm-iframedialog');
  public titleId: string = 'wmdialog-' + generateGUId();

  override width:string;
  message: string;
  oktext: string;
  title: string;
  iconclass: string;
  errMsg: string;
  iconurl: string;
  iconmargin: string;
  iconheight: string;
  iconwidth: string;
  class: string;
  hint: string;
  hintMsg: string;
  url: string;
  _iframesrc: SafeResourceUrl;
  loadDialogContent: boolean = false;
  headinglevel: string = 'h4';
  isPrism: boolean;

  constructor(inj: Injector,
              @Optional() viewParent: Parent, private trustAsPipe: TrustAsPipe) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    const projectService = runtimeEventManager.getService('projectService');
    this.isPrism = projectService.isPrism();
     this.registerPropertyChangeListener((key: string, nv: any, ov?: any) => {
      if (key === "height") {
        setCSS(this.nativeElement as HTMLElement, key, 'auto');
        const el = this.nativeElement.querySelector('.dialog-view .app-dialog') as HTMLElement;
        if (el) {
          setCSS(el, key, 'auto');
        }
      }else if (key === "width") {
        setCSS(this.nativeElement as HTMLElement, key, '100%');
      }
    })
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.url)
    this._iframesrc = this.trustAsPipe.transform(this.url, SecurityContext.RESOURCE_URL);
  }
  override get stylerEl(): HTMLElement | null {
    return this.nativeElement.querySelector('.modal-dialog');
  }

  override onStyleChange(key: string, nv: any, ov?: any) {
    if (key === 'height' && nv !== ov) {
      this.$element.find('.modal-body').css('height', nv);
    }
  }
}

